import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";
import FixedNavBar from "@/components/fixedNavBar";
import { Image, InfiniteScroll, PullToRefresh } from "antd-mobile";
import ChartsMonthly from "./comp/ChartsMonthly";
import { DownFill } from "antd-mobile-icons";
import useRouter from "@/hooks/useRouter";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import CustomEmpty from "@/components/Empty";
import { useAgentHomeMember } from "@/hooks/useOrderRecords";
import usePopup from "@/hooks/usePopup";
import SortBy from "./comp/SortBy";
import RewardsPlan from "./comp/RewardsPlan";
import useCustomTranslation from "@/hooks/useTranslation";
import { getUserInfoMethod } from "@/redux/reducers/authSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import TinyChens from "@/components/tinyChen/list";

const Members: React.FC = () => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const { customNavigate } = useRouter();
	// 先驱者用着
	const [firstPage, setFirstPage] = useState(true);
	//  sort/默认根据创建时间倒序 1/根据余额排序
	const [bySortValue, setBySortValue] = useState(0);
	const bySortList = [
		{
			sort: 0,
			name: "SortByTime",
			profit: "DaysTotalProfit",
		},
		{
			sort: 1,
			name: "SortByBalance",
			profit: "DaysTotalProfit",
		},
		{
			sort: 2,
			name: "SortByProfit",
			profit: "DaysTotalProfit",
		},
		{
			sort: 3,
			name: "SortBy30DaysProfit",
			profit: "Days30Profit",
		},
		{
			sort: 4,
			name: "SortBy7DaysProfit",
			profit: "Days7Profit",
		},
	];
	const SortByPopup = usePopup();
	const { agentList, membersData, hasMore, handleRefresh, handleFetchMore } =
		useAgentHomeMember({ sort: bySortList[bySortValue].sort });

	const onSubmitHandle = (value: number) => {
		setBySortValue(value);
		SortByPopup.closePopup();
	};

	useEffect(() => {
		if (!firstPage) handleRefresh();
		setFirstPage(false);
	}, [bySortValue]);

	useEffect(() => {
		dispatch(getUserInfoMethod());
	}, []);

	return (
		<div className="router-main">
			<FixedNavBar title={t("Members")} />
			<div className="router-view">
				<PullToRefresh
					onRefresh={handleRefresh}
					canReleaseText={t("canReleaseText")}
					completeText={t("completeText")}
					pullingText={t("pullingText")}
					refreshingText={t("refreshingText")}
				>
					<ChartsMonthly data={agentList} />
					<div className={classes.MembersWrap}>
						<div className={classes.searchFor}>
							<div
								onClick={() => customNavigate("/search-result")}
								className="members"
							>
								<span>
									{t("Search")} {t("Members")}
								</span>
								<Image
									src={require("@/assets/images/icons/search.png")}
									width={22}
									height={22}
								/>
							</div>
							<div
								onClick={SortByPopup.showPopup}
								className="members"
							>
								<span>{t(bySortList[bySortValue].name)}</span>
								<DownFill color="#5E71B7" fontSize={12} />
							</div>
						</div>
						{/* <RewardsPlan onRefresh={handleRefresh} /> */}
						{membersData.length === 0 ? (
							<CustomEmpty />
						) : (
							<TinyChens
								membersData={membersData}
								profit={t(bySortList[bySortValue].profit)}
							></TinyChens>
						)}
						{membersData.length > 0 && (
							<InfiniteScroll
								loadMore={handleFetchMore}
								hasMore={hasMore}
							>
								<InfiniteScrollContent hasMore={hasMore} />
							</InfiniteScroll>
						)}
					</div>
				</PullToRefresh>
			</div>

			<SortByPopup.PopupComp
				visible={SortByPopup.visiblePopup}
				onClose={SortByPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					SortByPopup.closePopup();
				}}
			>
				<SortBy
					onVisiblePopup={SortByPopup.closePopup}
					onSubmit={onSubmitHandle}
					data={bySortList}
				/>
			</SortByPopup.PopupComp>
		</div>
	);
};

export default Members;

const useStyles = createUseStyles({
	MembersWrap: {
		display: "flex",
		flexDirection: "column",
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(30),
		},
	},
	searchFor: {
		padding: {
			top: pxToRem(10),
			bottom: pxToRem(10),
		},
		"& .members": {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			height: pxToRem(36),
			color: "#76819F",
			fontSize: pxToRem(15),
			fontWeight: "500",
			padding: {
				left: pxToRem(18),
				right: pxToRem(18),
			},
			borderRadius: pxToRem(40),
			border: "1px solid #3A375D",
			backgroundColor: "#181B24",
			"& span": {
				paddingRight: pxToRem(8),
			},
			"&:first-of-type": {
				margin: {
					bottom: pxToRem(10),
				},
			},
		},
	},
});
